export const ADJUST_LESSON_SPEED = 'ADJUST_LESSON_SPEED';
export const SET_DEFAULT_LESSON_SPEED = 'SET_DEFAULT_LESSON_SPEED';
export const SHOW_SPEED_BUTTON = 'SHOW_SPEED_BUTTON';

// export const START_LESSON = 'START_LESSON';